<template>
  <div class="flex flex-wrap">
    <contact-autocomplete
      v-if="isAuth"
      v-model="name"
      :search-params="searchParams"
      big
      label="ФИО"
      required
      value-key="name"
      value-template="{name}"
      title-template="{name}"
      class="mt-15"
      :rules="[formRules.required]"
      :clear-value-after-blur="false"
      :disabled="disabled || partDisabled"
      @change="onChangeContractor"
    />
    <vz-input
      v-else
      v-model="name"
      label="ФИО"
      required
      big
      class="mt-15"
      :disabled="disabled || partDisabled"
      :rules="[formRules.required]"
    />
    <div v-if="corporationMatch" class="color-inactive">
      Рекомендуем оформлять {{ corporationMatch }} как юридическое лицо
    </div>
    <vz-phone-list
      v-model="orderForm.customer[direction][type].phone"
      :rules="[formRules.required, formRules.phone]"
      :disabled="disabled"
      :crutch-country="countrySelector"
    />

    <vz-input
      v-if="useEmail"
      v-model.trim="email"
      class="mt-15 mb-15"
      big
      label="Email"
      :rules="[formRules.email]"
      :disabled="disabled"
    />
  </div>
</template>

<script setup lang="ts">
import { PropType } from 'vue';
import formRules from '~/common/vz-form-rules';
import { DirectionName } from '~/types/types';
import {ContractListPostData} from '~/types/api';
import ContactAutocomplete from '~/components/autocomplete/contact-autocomplete.vue';
import VzPhoneList from '~/components/ui-kit/vz-phone-list.vue';
import {storeToRefs} from 'pinia';
import {useUserStore} from '~/stores/personal/user';
import VzInput from "~/components/ui-kit/vz-input.vue";

const props = defineProps({
  direction: {
    type: String as PropType<DirectionName>,
    default: 'dispatch'
  },
  disabled: {
    type: Boolean,
    default: false
  },
  partDisabled: {
    type: Boolean,
    default: false
  },
  useEmail: {
    type: Boolean,
    default: true
  },
  // todo remove
  isOrderPage: {
    type: Boolean,
    default: true
  }
})

const { isAuth } = storeToRefs(useUserStore())

const {
  phones,
  countrySelector,
  email,
  type,
  orderForm,
  onChangeContractor,
} = useMembers(props)

const searchParams: ContractListPostData = {
  daData: false,
  entity: 'individual',
  limit: 20,
  page: 1,
  useContact: true
}

const name = computed({
  get() {
    return orderForm.value.customer[props.direction].individual.name.value
  },
  set(value: string) {
    orderForm.value.customer[props.direction].individual.name.value = value
  }
})

const corporationMatch = computed(() => {
  const match = name.value.match(/^(ип|ооо|оао|зао)\s.*/i)
  return match?.length ? match[match.length - 1]?.toUpperCase() : false
})
</script>
